export default {
  'app.pwa.offline': '現在オフラインです',
  'app.pwa.serviceworker.updated': '新しいコンテンツが利用可能です',
  'app.pwa.serviceworker.updated.hint':
    '「更新」ボタンを押して現在のページを再読み込みしてください',
  'app.pwa.serviceworker.updated.ok': '更新',
};
